export default __webpack_public_path__ + "static/media/PM_LOGO_FINAL-04.d97e0406.png";